import { render, staticRenderFns } from "./ControlOrderFood.vue?vue&type=template&id=ec429aaa"
import script from "./ControlOrderFood.vue?vue&type=script&lang=js"
export * from "./ControlOrderFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports